var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"mb-3 mt-3"},[_c('b-col',{attrs:{"cols":"12"},domProps:{"innerHTML":_vm._s(_vm.data.content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }